import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CashPlusFacade } from "@modules/cashplus/+state/cashplus.facade";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { CashplusNavigationService } from "@modules/cashplus/infrastructure/cashplus-navigation.service";
import { CashplusPortfolioFacade } from "@modules/cashplus/+state/cashplus-portfolio.facade";
import { CashPlusTrackingFacade } from "@modules/cashplus/+state/cashplus-tracking.facade";

@Injectable({ providedIn: "root" })
export class CashplusOptOutFacade {
	private isApiOutLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(
		private readonly cashPlusFacade: CashPlusFacade,
		private readonly cashPlusNavigationService: CashplusNavigationService,
		private readonly infoService: InfoService,
		private readonly cashPlusPortfolioFacade: CashplusPortfolioFacade,
		private readonly translationService: TranslationService,
		private readonly cashPlusTrackingFacade: CashPlusTrackingFacade
	) {}

	public onOptOutRequest(): void {
		this.cashPlusTrackingFacade.turnOffCashPlusBtnClicked();
		this.isApiOutLoading$.next(true);
		this.cashPlusFacade
			.optOut$()
			.subscribe({
				next: (response) => {
					// @ts-ignore
					if (response.status === 202) {
						this.cashPlusPortfolioFacade.setFundReleasePending();
						this.infoService.setWarning(this.translationService.translate("cash_plus_opt_out_pending"));
					} else {
						this.cashPlusPortfolioFacade.setFundReleaseFinished();
						this.cashPlusFacade.updateSubscriptionState(false);
						this.cashPlusFacade.fetchPortfolioFiatConfigForAllFiat(true);
						this.infoService.setSuccess(this.translationService.translate("cash_plus_opt_out_message"));
					}
					this.cashPlusNavigationService.closeModal();
				},
				error: () => {
					this.infoService.setError(this.translationService.translate("cash_plus_opt_error_message"));
				}
			})
			.add(() => {
				this.isApiOutLoading$.next(false);
			});
	}

	public isOptOutInProgress$(): Observable<boolean> {
		return this.isApiOutLoading$.asObservable();
	}
}
